/**
 * `<UserText>` — the renderer for **user-authored plain-text prose**: freeform notes a
 * player typed, not lancer-data rules text.
 *
 * **Never `RulesText`.** `RulesText` parses the lancer-data HTML subset (`<br>`-delimited
 * paragraphs, no real `\n`) — a different grammar with different trust properties. Feeding
 * user text to it renders `\n`-delimited prose as one undifferentiated block and reads a
 * user's literal `<` as markup. There is deliberately no alias from this component to that
 * one; import the right one for the source of the text.
 *
 * **No `dangerouslySetInnerHTML`, ever.** `text` is handed to React as an ordinary text
 * child, so React escapes it — the only thing standing between a user-authored `<` and
 * another player's DOM once `SHARED_SHEET_DISCLOSURE.notes = "shown"` puts this prose on a
 * second player's screen. Newlines are real `\n`; layout is `white-space: pre-wrap`, no
 * markdown, no HTML.
 */
export function UserText({ text, className }: { text: string; className?: string }) {
  return (
    <div className={className} style={{ whiteSpace: "pre-wrap" }}>
      {text}
    </div>
  );
}
